import React, { useContext, useState } from 'react';
import { styled } from '@mui/material/styles';
import { AppContext } from '@/AppContext';
import { MeetupContext } from '@/MeetupContext';
import ModalDialog from '@/components/ModalDialog/ModalDialog';
import Grid from '@mui/material/Grid';
import Stepper from '@mui/material/Stepper';
import { StepConnector } from '@mui/material';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import clsx from 'clsx';
import { Check, CloudUpload, InsertDriveFile, PlaylistAddCheck, Publish, TextFields } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { SelectFileStep } from './steps/SelectFileStep';
import { ValidationStep } from './steps/ValidationStep';
import { FieldsSetupStep } from './steps/FieldsSetupStep';
import { FinishStep } from './steps/FinishStep';
import ErrorBlock from 'components/ErrorBlock/ErrorBlock';

const PREFIX = 'ImportVisitors';

const classes = {
  vertical: `${PREFIX}-vertical`,
  line: `${PREFIX}-line`,
  root: `${PREFIX}-root`,
  active: `${PREFIX}-active`,
  completed: `${PREFIX}-completed`,
};

const StyledModalDialog = styled(ModalDialog)(({ theme }) => ({
  [`& .${classes.root}`]: {},

  [`& .${classes.active}`]: {
    backgroundColor: theme.palette.secondary.main,
    boxShadow: theme.shadows[10],
  },

  [`& .${classes.completed}`]: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  [`&.${classes.root}`]: {},

  [`&.${classes.active}`]: {
    backgroundColor: theme.palette.secondary.main,
    boxShadow: theme.shadows[10],
  },

  [`&.${classes.completed}`]: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

const steps = [
  {
    label: 'Выбор файла',
    icon: InsertDriveFile,
  },
  {
    label: 'Настройка полей',
    icon: TextFields,
  },
  {
    label: 'Валидация',
    icon: PlaylistAddCheck,
  },
  {
    label: 'Загрузка',
    icon: CloudUpload,
  },
];

const CustomStepConnector = StepConnector;

// Styles are now handled by StyledModalDialog

function CustomStepIcon({ active, completed, icon }) {
  const Icon = steps[icon - 1].icon;

  return (
    <StyledAvatar
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      <Icon size='20' />
    </StyledAvatar>
  );
}

const ImportVisitors = props => {
  const { backAndRefresh } = props;

  const [activeStep, setActiveStep] = useState(0);
  const [stepData, setStepData] = useState([
    {},
    { mapping: {}, settings: {} },
    { onDuplicate: 'skip', onError: 'stop' },
    {},
  ]);
  const [error, setError] = useState();

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  return (
    <StyledModalDialog title={'Импорт участников'} size={'md'} handleClose={backAndRefresh} noButtons={true}>
      <ErrorBlock message={error} />
      <Grid container>
        <Grid
          size={{
            xs: 12,
            md: 3,
          }}
        >
          <Stepper
            activeStep={activeStep}
            connector={
              <CustomStepConnector
                classes={{
                  vertical: classes.vertical,
                  line: classes.line,
                }}
              />
            }
            orientation='vertical'
            component={Box}
            bgcolor='transparent'
          >
            {steps.map(step => (
              <Step key={step.label}>
                <StepLabel StepIconComponent={CustomStepIcon}>{step.label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 9,
          }}
        >
          <Box p={3}>
            {activeStep === 0 && (
              <SelectFileStep data={stepData[0]} onChange={d => setStepData([d, stepData[1], stepData[2]])} />
            )}
            {activeStep === 1 && (
              <FieldsSetupStep stepData={stepData} onChange={d => setStepData([stepData[0], d, stepData[2]])} />
            )}
            {activeStep === 2 && (
              <ValidationStep stepData={stepData} onChange={d => setStepData([stepData[0], stepData[1], d])} />
            )}
            {activeStep === 3 && <FinishStep stepData={stepData} error={error} setError={setError} />}
          </Box>
        </Grid>
        <Grid
          size={{
            xs: false,
            md: 4,
          }}
        ></Grid>
        <Grid
          size={{
            xs: 12,
            md: 7,
          }}
        >
          <Box mt={6} display='flex'>
            {activeStep > 0 && activeStep !== 3 && (
              <Button onClick={handleBack} size='large'>
                Назад
              </Button>
            )}
            <Box flexGrow={1} />
            {activeStep < 3 && (
              <Button
                color='secondary'
                onClick={handleNext}
                type='submit'
                variant='contained'
                disabled={!stepData[activeStep].ready}
                size='large'
              >
                {activeStep !== 2 ? 'Дальше' : 'Загрузить'}
              </Button>
            )}
            {activeStep === 3 && (
              <Button color='primary' onClick={backAndRefresh} type='submit' variant='contained' size='large'>
                Завершить
              </Button>
            )}
          </Box>
        </Grid>
      </Grid>
    </StyledModalDialog>
  );
};

export default ImportVisitors;
